// ** Icons Import
import {
  FileText,
  Circle,
  Navigation2,
  DollarSign,
  Users,
  Activity
} from 'react-feather'

export default [
  {
    header: 'PERIODO ACTUAL',
    action: 'common',
    resource: 'tollSystem'
  },
  {
    id: 'dashboard',
    title: 'Resumen',
    icon: <Activity size={20} />,
    action: 'concesion-level-1',
    resource: 'tollSystem',
    navLink: '/toll-system/concession/dashboard'
  },
  {
    id: 'Tickets',
    title: 'Viajes',
    action: 'concesion-level-0',
    resource: 'tollSystem',
    icon: <FileText size={20} />,
    children: [
      {
        id: 'History',
        title: 'Historial',
        action: 'concesion-level-0',
        resource: 'tollSystem',
        icon: <Circle size={12} />,
        navLink: '/toll-system/movements/tickets/list'
      },
      {
        id: 'Paquetes',
        title: 'Paquetes',
        action: 'concesion-level-0',
        resource: 'tollSystem',
        icon: <Circle size={12} />,
        navLink: '/toll-system/movements/bundles'
      }
    ]
  },
  // {
  //   id: 'Parking',
  //   title: 'Parquimetros',
  //   action: 'concession-level-0',
  //   resource: 'tollSystem',
  //   icon: <FileText size={20} />,
  //   children: [
  //     {
  //       id: 'History',
  //       title: 'Historial',
  //       action: 'concession-level-0',
  //       resource: 'tollSystem',
  //       icon: <Circle size={12} />,
  //       navLink: '/parking/list'
  //     }
  //   ]
  // },
  {
    header: 'Comercialización',
    action: 'common',
    resource: 'tollSystem'
  },
  {
    id: 'vehicles',
    title: 'Vehículos',
    icon: <Navigation2 size={20} />,
    action: 'concesion-level-1',
    resource: 'tollSystem',
    children: [
      {
        id: 'Registro',
        title: 'Registro',
        icon: <Circle size={12} />,
        action: 'concesion-level-1',
        resource: 'tollSystem',
        navLink: '/toll-system/vehicles/register'
      }
    ]
  }
]
